export default __webpack_public_path__ + "static/media/logo-interbrasil-login.29dffdc9.webp";